module.exports = __webpack_public_path__ + "static/media/cal-6.63a34796.jpg";